/* eslint-disable import/prefer-default-export */
import { get, post } from 'utils/methods';

export function getPrepressApi(data, headers) {
    return get(`${process.env.REACT_APP_REST_PP}errors`, data, headers);
}

export function togglePrepressStatusApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_PP}commands/error/status`, data, headers);
}
